var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000004631(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38508 1.64497C9.27212 0.741425 10.7279 0.741426 11.6149 1.64497V1.64497C12.1327 2.17242 12.8755 2.41376 13.6045 2.29141V2.29141C14.8532 2.08182 16.0309 2.93749 16.2175 4.18987V4.18987C16.3264 4.92095 16.7854 5.55279 17.4471 5.88227V5.88227C18.5805 6.44669 19.0304 7.8312 18.4451 8.95404V8.95404C18.1035 9.6095 18.1035 10.3905 18.4451 11.046V11.046C19.0304 12.1688 18.5805 13.5533 17.4471 14.1177V14.1177C16.7854 14.4472 16.3264 15.079 16.2175 15.8101V15.8101C16.0309 17.0625 14.8532 17.9182 13.6045 17.7086V17.7086C12.8755 17.5862 12.1327 17.8276 11.6149 18.355V18.355C10.7279 19.2586 9.27212 19.2586 8.38508 18.355V18.355C7.86726 17.8276 7.12449 17.5862 6.39554 17.7086V17.7086C5.14682 17.9182 3.96908 17.0625 3.78254 15.8101V15.8101C3.67364 15.079 3.21459 14.4472 2.55293 14.1177V14.1177C1.4195 13.5533 0.969644 12.1688 1.55486 11.046V11.046C1.89648 10.3905 1.89648 9.6095 1.55486 8.95404V8.95404C0.969644 7.8312 1.4195 6.44669 2.55293 5.88227V5.88227C3.21459 5.55279 3.67364 4.92095 3.78254 4.18987V4.18987C3.96908 2.93749 5.14682 2.08182 6.39554 2.29141V2.29141C7.12449 2.41376 7.86726 2.17242 8.38508 1.64497V1.64497Z",
    fill: "url(#paint0_linear_3376_1139)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14704 19.8528C4.32351 19.7352 3.92155 18.9215 3.82351 18.5293L1.91174 22.9411L5.44115 22.6469L7.35292 25.5881L9.26468 21.0293L7.64704 19.5587C7.15684 19.7058 5.97057 19.9705 5.14704 19.8528Z",
    fill: "url(#paint1_linear_3376_1139)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2941 19.8528C16.1177 19.7352 16.5196 18.9215 16.6177 18.5293L18.5294 22.9411L15 22.6469L13.0882 25.5881L11.1765 21.0293L12.7941 19.5587C13.2843 19.7058 14.4706 19.9705 15.2941 19.8528Z",
    fill: "url(#paint2_linear_3376_1139)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34641 11.8495C8.9747 11.3259 9.47537 10.8907 9.84842 10.5439C10.2215 10.1904 10.5323 9.82394 10.781 9.44434C11.0297 9.06475 11.1541 8.6917 11.1541 8.3252C11.1541 7.99142 11.0756 7.72963 10.9185 7.53984C10.7614 7.35004 10.5193 7.25514 10.192 7.25514C9.86478 7.25514 9.61281 7.3664 9.43611 7.58892C9.2594 7.8049 9.16777 8.10268 9.16123 8.48227H7.82611C7.85229 7.69691 8.08463 7.10134 8.52312 6.69557C8.96816 6.2898 9.531 6.08691 10.2117 6.08691C10.9577 6.08691 11.5304 6.28653 11.9296 6.68575C12.3289 7.07844 12.5285 7.59874 12.5285 8.24666C12.5285 8.75715 12.391 9.24473 12.1162 9.7094C11.8413 10.1741 11.5271 10.5798 11.1737 10.9267C10.8203 11.267 10.3589 11.6794 9.78952 12.1637H12.6855V13.3024H7.83593V12.2815L8.34641 11.8495Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3376_1139",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C8FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3875CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3376_1139",
    x1: 5.58821,
    y1: 18.5293,
    x2: 5.58821,
    y2: 25.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C8FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3875CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3376_1139",
    x1: 14.8529,
    y1: 18.5293,
    x2: 14.8529,
    y2: 25.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C8FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3875CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000004631);
export default __webpack_public_path__ + "static/media/Group 1000004631.0c098ab0d41091f951f63a2770b8c708.svg";
export { ForwardRef as ReactComponent };